var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGuest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "teams 2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11584",
    d: "M9.998 3.643a2.407 2.407 0 00-1.693.692 2.408 2.408 0 00-.728 1.673 3.521 3.521 0 00.783 2.1 2.208 2.208 0 001.64.938 2.21 2.21 0 001.64-.938 3.523 3.523 0 00.784-2.1 2.418 2.418 0 00-2.374-2.364h-.052m-.112 8.644a9.978 9.978 0 00-4.247.956 2.11 2.11 0 00-1.175 1.894v1.373h11.071v-1.372a2.111 2.111 0 00-1.175-1.9 9.978 9.978 0 00-4.247-.956h-.227m.113-9.644h.071a3.425 3.425 0 013.354 3.354c0 1.891-1.533 4.045-3.424 4.045S6.577 7.883 6.577 5.993a3.424 3.424 0 013.422-3.35zm-.113 8.644h.227a10.915 10.915 0 014.683 1.056 3.123 3.123 0 011.739 2.798v2.374H3.464v-2.374a3.123 3.123 0 011.739-2.794 10.915 10.915 0 014.683-1.056z",
    fill: "currentColor"
  }))));
}

export default SvgGuest;